import React, { useEffect, useState } from "react";
import "./ProjectSetup.css";
import filesUpload from "../../assets/icons/filesUpload.svg";
import infoIcon from "../../assets/icons/Info-Circle.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  getAllGuidelinesWcag,
  createFeature,
  guidelinesWcagPatch,
} from "../../services/homeService";
import { setAllGuidelinesWcag } from "../../store/slice/setupSlice";
import * as XLSX from "xlsx";
import EditableDropdown from "./EditableDropDown";
import { setIsProjectSetup } from "../../store/slice/setupSlice.js";
import { setSelectedProject } from "../../store/slice/bugSlice.js";
import { useNavigate, useParams } from "react-router-dom";
import { getFeatureByProjId } from "../../services/homeService.js";
import WcagGuidelines from "../../Components/WcagGuidelines/WcagGuidelines.jsx";

const ProjectSetup = ({ handleBack }) => {
  const { selectedProject } = useSelector((state) => {
    return state.bugDetails;
  });
  const { allGuidelinesWcag, wcagGuidelinesPayload } = useSelector((state) => {
    return state.setupDetails;
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { clientId } = useParams();
  const { selectedClient } = useSelector((state) => {
    return state.clientDetails;
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [newFeatureColumn, setNewFeatureColumn] = useState(false);
  const [dragging, setDragging] = useState(false);
  const [files, setFiles] = useState([]);
  const [fileDropOccurred, setFileDropOccurred] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [excelDataId, setExcelDataId] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [editedOption, setEditedOption] = useState("");
  const [selectedVersions, setSelectedVersions] = useState([]);
  const [isGuidelineRender, setIsGuidelineRender] = useState(false)
  // const [selectedVersions, setSelectedVersions] = useState(['2.0', '2.1']);
  // const [selectedVersions, setSelectedVersions] = useState(['2.1','2.2']);

  const handleDragEnter = (e) => {
    e.preventDefault();
    setDragging(true);
  };

  const handleDragLeave = () => {
    setDragging(false);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setDragging(false);
    const droppedFiles = Array.from(e.dataTransfer.files);
    handleFileOnDrop(droppedFiles);
    setFileDropOccurred(true);
  };
  const handleFileOnDrop = (e) => {
    const file = e[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });

        // Assuming the first sheet is the one you want to read
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Convert sheet data to JSON
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        setExcelData(jsonData);
      };

      reader.readAsBinaryString(file);
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });

        // Assuming the first sheet is the one you want to read
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Convert sheet data to JSON
        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1 });

        setExcelData(jsonData);
      };

      reader.readAsBinaryString(file);
    }
  };

  const addNewFeature = () => {
    setNewFeatureColumn(true);
    setEditMode(false);
    setEditedOption("");
  };

  const getFeatureList = async () => {
    try {
      const [featureResp] = await Promise.all([
        getFeatureByProjId(selectedProject.id),
      ]);

      if (featureResp) {
        setExcelData(
          featureResp?.map((feature) => {
            return [feature?.name];
          })
        );
        setExcelDataId(
          featureResp.reduce((acc, feature) => {
            acc[feature.name] = feature.id;
            return acc;
          }, {})
        );
        getAllGuidelinesWcagApi(selectedProject.id);
      } else {
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const getAllGuidelinesWcagApi = async (projId) => {
    try {
      const resp = await getAllGuidelinesWcag(projId);
      dispatch(setAllGuidelinesWcag(resp.wcagListing));
      setSelectedVersions(resp.selectedVersionsPayload)
      setIsGuidelineRender(!isGuidelineRender);
    } catch (error) {
      console.error("Error fetching clients:", error.message);
    }
  };

  useEffect(() => {
    getFeatureList();
    
    // Check if project already has features (is set up)
    if (selectedProject && selectedProject.featureCount > 0) {
      // Project has been set up, cache is already updated
      console.log('Project has been set up, modifying existing setup');
    }
  }, []);

  const createFeatureApi = async (projID) => {
    try {
      let payload = excelData?.map((feature) => {
        const featureId = excelDataId[feature[0]] || 0;
        return {
          id: featureId,
          name: feature[0],
        };
      });

      let payloadGuidelines = wcagGuidelinesPayload.listADataPayload.concat(wcagGuidelinesPayload.listAADataPayload);
      const resp1 = await createFeature(payload, projID);
      const resp2 = await guidelinesWcagPatch(projID, payloadGuidelines);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSaveBtn = async() => {
    await createFeatureApi(selectedProject.id);
    
    // Set project setup to false before navigation
    dispatch(setIsProjectSetup(false));
    
    // Get updated project information to update the cached data
    try {
      // Update the project in the Redux store with the new feature count
      // This ensures the buttons (Modify, Bugs, Dashboard) will be updated correctly
      const updatedProject = {
        ...selectedProject,
        featureCount: excelData.length || 0  // Update feature count based on the data we have
      };
      
      // Update the selectedProject in Redux store with the updated feature count
      // This will change the setup button to "Modify" and activate the bugs button
      dispatch(setSelectedProject(updatedProject));
      
      // Prepare to navigate back to the projects page
      const state = { 
        clientName: selectedClient.label,
        refreshNeeded: true // Signal that we need to refresh the projects list
      };
      
      // Navigate back to the client page
      navigate(`./client/${clientId}`, { state });
    } catch (error) {
      console.error("Error updating project data:", error);
      // Navigate anyway even if there was an error
      const state = { clientName: selectedClient.label };
      navigate(`./client/${clientId}`, { state });
    }
  };

  return (
    <>
      <div>
        <h2 className="projtitle">Project: {selectedProject?.name}</h2>
      </div>
      <div className="panel-wrapper">
        <div className="left-panel-feature">
          <div className="icons">
            <div style={{ display: "flex", alignItems: "center" }}>
              <span className="text">Add Feature List</span>
              <img
                src={infoIcon}
                alt="infoIcon"
                style={{ marginLeft: "5px" }}
                draggable={false}
              ></img>
            </div>
            <button
              onClick={addNewFeature}
              className="feature-Button"
            >
              Add New Feature
            </button>
          </div>
          <div className="folderDropWrapper">
            {(excelData?.length || newFeatureColumn) ? (
              <EditableDropdown
                setExcelData={setExcelData}
                data={excelData}
                newFeatureColumn={newFeatureColumn}
                setNewFeatureColumn={setNewFeatureColumn}
                editMode={editMode}
                setEditMode={setEditMode}
                editedOption={editedOption}
                setEditedOption={setEditedOption}
                excelDataId={excelDataId}
              />
            ) : (
              <>
                <label htmlFor="fileInput">
                  <img
                    className="image"
                    src={filesUpload}
                    alt="Files Upload"
                    draggable={false}
                    style={{
                      cursor: "pointer",
                      zIndex: "1",
                      position: "relative",
                      display: "block",
                      marginLeft: "auto",
                      marginRight: "auto",
                      width: "50%",
                    }}
                  />
                </label>
                <input
                  type="file"
                  id="fileInput"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                  accept=".xls, .xlsx" // Specify accepted file types if needed
                />
                <div
                  className={`file-drop-container ${
                    dragging ? "dragging" : ""
                  }`}
                  onDragEnter={handleDragEnter}
                  onDragLeave={handleDragLeave}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                >
                  <ul>
                    {files.map((file) => (
                      <li key={file.name}>{file.name}</li>
                    ))}
                  </ul>
                </div>
                <div className="text">
                  <span>Drag and drop to upload file</span>
                  <span style={{ fontWeight: "700" }}>or</span>
                  <span>
                    Select file from computer to add feature list in project
                  </span>
                </div>
              </>
            )}
          </div>
        </div>
        <WcagGuidelines allGuidelinesWcag ={allGuidelinesWcag} selectedVersions={selectedVersions} setSelectedVersions={setSelectedVersions} excelData={excelData} isGuidelineRender={isGuidelineRender}/>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginRight: "50px",
          marginTop: "30px",
        }}
      >
        <button className="backBtn" onClick={handleBack}>
          Back
        </button>
        <button onClick={handleSaveBtn} className={(!excelData.length || !selectedVersions.length || ( !wcagGuidelinesPayload?.listAADataPayload.length && !wcagGuidelinesPayload?.listADataPayload.length)) ? "disable saveBtn" :"saveBtn"}>
          Save
        </button>
      </div>
    </>
  );
};

export default ProjectSetup;
